module.exports = __webpack_public_path__ + "static/media/automation_crawling_links.7f82e0e2.gif";